import React, { useState } from 'react';
import { SearchIcon, FilterIcon, PackageIcon, TruckIcon, CheckCircleIcon, XCircleIcon, ClockIcon } from 'lucide-react';
import { OrderDetailsModal } from './modals/OrderDetailsModal';
import { ReturnRequestModal } from './modals/ReturnRequestModal';
export function OrdersSection() {
  const [filter, setFilter] = useState('all');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetailsOpen, setOrderDetailsOpen] = useState(false);
  const [returnModalOpen, setReturnModalOpen] = useState(false);
  const orders = [{
    id: 'ORD-12345',
    date: '2024-01-15',
    total: 125.5,
    status: 'Delivered',
    items: [{
      id: 1,
      name: 'Panadol Extra Pain Relief Tablets 24s',
      quantity: 2,
      price: 12.99,
      image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop'
    }, {
      id: 2,
      name: 'Vitamin D3 Supplement',
      quantity: 1,
      price: 24.99,
      image: 'https://images.unsplash.com/photo-1550572017-4bfa2d5c8f1d?w=400&h=400&fit=crop'
    }],
    trackingNumber: 'TRK123456789',
    shippingAddress: 'King Fahd Road, Al Olaya, Riyadh'
  }, {
    id: 'ORD-12344',
    date: '2024-01-10',
    total: 75.25,
    status: 'Processing',
    items: [{
      id: 3,
      name: 'Blood Pressure Monitor',
      quantity: 1,
      price: 75.25,
      image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=400&h=400&fit=crop'
    }],
    shippingAddress: 'Prince Turki Street, Al Malqa, Riyadh'
  }, {
    id: 'ORD-12343',
    date: '2024-01-05',
    total: 210.0,
    status: 'Shipped',
    items: [{
      id: 4,
      name: 'First Aid Kit',
      quantity: 1,
      price: 45.99,
      image: 'https://images.unsplash.com/photo-1603398938378-e54eab446dde?w=400&h=400&fit=crop'
    }, {
      id: 5,
      name: 'Omega-3 Fish Oil',
      quantity: 3,
      price: 54.67,
      image: 'https://images.unsplash.com/photo-1550572017-4bfa2d5c8f1d?w=400&h=400&fit=crop'
    }],
    trackingNumber: 'TRK123456788',
    shippingAddress: 'King Fahd Road, Al Olaya, Riyadh'
  }, {
    id: 'ORD-12342',
    date: '2023-12-28',
    total: 45.99,
    status: 'Cancelled',
    items: [{
      id: 6,
      name: 'Digital Thermometer',
      quantity: 1,
      price: 45.99,
      image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop'
    }],
    shippingAddress: 'King Fahd Road, Al Olaya, Riyadh'
  }];
  const filteredOrders = filter === 'all' ? orders : orders.filter(order => order.status.toLowerCase() === filter);
  const getStatusConfig = status => {
    switch (status) {
      case 'Delivered':
        return {
          color: 'bg-green-50 text-green-700 border-green-200',
          icon: CheckCircleIcon,
          iconColor: 'text-green-600'
        };
      case 'Processing':
        return {
          color: 'bg-blue-50 text-blue-700 border-blue-200',
          icon: ClockIcon,
          iconColor: 'text-blue-600'
        };
      case 'Shipped':
        return {
          color: 'bg-purple-50 text-purple-700 border-purple-200',
          icon: TruckIcon,
          iconColor: 'text-purple-600'
        };
      case 'Cancelled':
        return {
          color: 'bg-red-50 text-red-700 border-red-200',
          icon: XCircleIcon,
          iconColor: 'text-red-600'
        };
      default:
        return {
          color: 'bg-gray-50 text-gray-700 border-gray-200',
          icon: PackageIcon,
          iconColor: 'text-gray-600'
        };
    }
  };
  const handleViewOrder = order => {
    setSelectedOrder(order);
    setOrderDetailsOpen(true);
  };
  const handleCancelOrder = order => {
    setOrderDetailsOpen(false);
    setSelectedOrder(order);
    // Small delay to ensure smooth transition between modals
    setTimeout(() => {
      setReturnModalOpen(true);
    }, 100);
  };
  const handleReturnRequest = (returnData: any) => {
    console.log('Return request submitted:', returnData);
    alert('Return request submitted successfully!');
  };
  return <div className="space-y-6" data-id="element-862" data-mp="2tory1x1quo8y">
      <h2 className="text-xl font-bold text-gray-900" data-id="element-863" data-mp="2osjmsuqo3f72">My Orders</h2>
      {/* Search and Filter */}
      <div className="flex flex-col md:flex-row gap-4" data-id="element-864" data-mp="33hfuursq4s7o">
        <div className="relative flex-grow" data-id="element-865" data-mp="33j0ngbvha12w">
          <input type="text" placeholder="Search orders..." className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-866" data-mp="2ypxsbzb1yjkl" />
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-867" data-mp="25zfqt2pz8q9a" />
        </div>
        <div className="flex items-center gap-2 md:w-auto" data-id="element-868" data-mp="qa7vr2qhphge">
          <FilterIcon className="w-5 h-5 text-gray-500" data-id="element-869" data-mp="qbiwsusjwb3t" />
          <select value={filter} onChange={e => setFilter(e.target.value)} className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-870" data-mp="bm37zkckyfqr">
            <option value="all" data-id="element-871" data-mp="14865futv8ppk">All Orders</option>
            <option value="delivered" data-id="element-872" data-mp="1980vjw5thb9k">Delivered</option>
            <option value="processing" data-id="element-873" data-mp="v9azmjuqhhms">Processing</option>
            <option value="shipped" data-id="element-874" data-mp="v8j5ldgsbrym">Shipped</option>
            <option value="cancelled" data-id="element-875" data-mp="zamfhxnt2ohs">Cancelled</option>
          </select>
        </div>
      </div>
      {/* Orders Grid */}
      {filteredOrders.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-876" data-mp="3fy8hbhm6yxn3">
          {filteredOrders.map(order => {
        const statusConfig = getStatusConfig(order.status);
        const StatusIcon = statusConfig.icon;
        return <div key={order.id} className="bg-white rounded-xl border-2 border-gray-200 shadow-sm hover:shadow-md transition-all p-6" data-id="element-877" data-mp="1lirw5lqjnw6e">
                <div className="flex items-start justify-between mb-4" data-id="element-878" data-mp="1bti6ecj6aplg">
                  <div className="flex items-center gap-3" data-id="element-879" data-mp="1brfgdsi0swgq">
                    <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0" data-id="element-880" data-mp="17sy5cxvhb1u1">
                      <PackageIcon className="w-6 h-6 text-[#1E2B55]" data-id="element-881" data-mp="12r8vhljzsu7j" />
                    </div>
                    <div data-id="element-882" data-mp="xu8ye054f1sk">
                      <h3 className="font-bold text-gray-900 text-lg" data-id="element-883" data-mp="xvk3c3aayfl9">
                        {order.id}
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-884" data-mp="2s89vafh41eq0">
                        {new Date(order.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                  })}{' '}
                        · {order.items.length}{' '}
                        {order.items.length === 1 ? 'item' : 'items'}
                      </p>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-885" data-mp="39gsvzmcmys24">
                    <p className="text-xl font-bold text-[#1E2B55] mb-1" data-id="element-886" data-mp="39gkne6njq8wq">
                      SAR {order.total.toFixed(2)}
                    </p>
                    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium border ${statusConfig.color}`} data-id="element-887" data-mp="2gs56fekutgir">
                      <StatusIcon className={`w-3.5 h-3.5 ${statusConfig.iconColor}`} data-id="element-888" data-mp="2qqkxjhjvsps9" />
                      {order.status}
                    </span>
                  </div>
                </div>
                {/* Order Items Preview */}
                <div className="mb-4 pb-4 border-b border-gray-100" data-id="element-889" data-mp="626rxjve73y2">
                  <div className="flex gap-2" data-id="element-890" data-mp="r4xq1pi8clc6">
                    {order.items.slice(0, 3).map(item => <div key={item.id} className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0" data-id="element-891" data-mp="n4nm0ie004zy">
                        <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-892" data-mp="w1y16etxsea5" />
                      </div>)}
                    {order.items.length > 3 && <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-893" data-mp="1jsaey6bv558n">
                        <span className="text-sm font-medium text-gray-600" data-id="element-894" data-mp="1es5y2f71m8hw">
                          +{order.items.length - 3}
                        </span>
                      </div>}
                  </div>
                </div>
                {/* Tracking Info */}
                {order.trackingNumber && <div className="mb-4 p-3 bg-blue-50 rounded-lg" data-id="element-895" data-mp="212nrm20on0cp">
                    <div className="flex items-center gap-2" data-id="element-896" data-mp="1nazga0y9cfws">
                      <TruckIcon className="w-4 h-4 text-blue-600" data-id="element-897" data-mp="1nahlz9v5obri" />
                      <span className="text-sm text-gray-700" data-id="element-898" data-mp="1rbt2mpw1xmnk">
                        Tracking Number:
                      </span>
                      <span className="text-sm font-medium text-blue-600" data-id="element-899" data-mp="1db8nq4t9cazc">
                        {order.trackingNumber}
                      </span>
                    </div>
                  </div>}
                {/* Actions */}
                <div className="flex flex-wrap gap-3" data-id="element-900" data-mp="18dgrwzphs4pv">
                  <button onClick={() => handleViewOrder(order)} className="flex-1 px-4 py-2 bg-[#1E2B55] text-white text-sm font-medium rounded-lg hover:bg-[#162041] transition-colors" data-id="element-901" data-mp="18e0bekusj160">
                    View Details
                  </button>
                  {order.status === 'Delivered' && <button className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors" data-id="element-902" data-mp="p9y3thh1ll00">
                      Buy Again
                    </button>}
                </div>
              </div>;
      })}
        </div> : <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-12 text-center" data-id="element-903" data-mp="139z691cyh0hl">
          <PackageIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-904" data-mp="1880q3oi7h3u4" />
          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-905" data-mp="u7pwwetfbd5s">
            No orders found
          </h3>
          <p className="text-gray-600" data-id="element-906" data-mp="y9begdgwkfmb">
            Try changing your filter or search for a different order
          </p>
        </div>}
      {/* Order Details Modal */}
      <OrderDetailsModal isOpen={orderDetailsOpen} onClose={() => setOrderDetailsOpen(false)} order={selectedOrder} onCancelOrder={handleCancelOrder} data-id="element-907" data-mp="3j13l9g2bk4md" />
      {/* Return Request Modal */}
      <ReturnRequestModal isOpen={returnModalOpen} onClose={() => setReturnModalOpen(false)} order={selectedOrder} onSubmit={handleReturnRequest} data-id="element-908" data-mp="36h6jawpxrh0z" />
    </div>;
}